import { Component, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { ConfigService } from './config.service';
import { GoogleMapsLoaderService } from './services/google-maps-loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false,
})
export class AppComponent implements OnInit, OnChanges, OnDestroy {
  title = 'POIS';
  items!: MenuItem[];
  home!: MenuItem;
  userValidation: any;
  subscription: Subscription = new Subscription();
  showHead: boolean = false;

  ngOnInit() {
    this.ngOnChanges();
    this.subscription = this.configService.getConfig().subscribe((res) => {
      console.info('[GoogleMaps] Config response received', { apiKeyPresent: !!res.body?.apiConfig });
      this.googleMapsLoader.load(res.body.apiConfig).catch((error) => console.error(error));
    });
    this.home = { icon: 'pi pi-home', routerLink: '/' };
  }

  constructor(
    private router: Router,
    private configService: ConfigService,
    private googleMapsLoader: GoogleMapsLoaderService
  ) {}

  ngOnChanges() {
    this.router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        if (event['url'] == '/login') {
          this.showHead = false;
        } else {
          this.showHead = true;
        }
      }
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

}
